import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import api from '../../utils/axiosInstance';
import {
    addproduct,
    updateproduct,
    deleteproduct,
    getallproducts,
} from '../../constant/routes';
import { getallProducts } from '../../actions/productActions';
import './Admin.css';

const EMPTY_FORM = {
    name: '', description: '', img1: '', img2: '',
    price: '', category: '', tags: '',
};

const AdminProducts = () => {
    const dispatch = useDispatch();
    const [products, setProducts] = useState([]);
    const [form, setForm] = useState(EMPTY_FORM);
    const [editId, setEditId] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchAll = async () => {
        const res = await api.get(`${getallproducts}?page=1&limit=1000`).catch(e => e);
        if (res.status === 200) setProducts(res.data.products || []);
    };

    useEffect(() => { fetchAll(); }, []); // eslint-disable-line

    const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        const payload = {
            ...form,
            price: Number(form.price),
            category: form.category.split(',').map(s => s.trim()).filter(Boolean),
            tags: form.tags.split(',').map(s => s.trim()).filter(Boolean),
        };

        let res;
        if (editId) {
            res = await api.put(updateproduct + editId, payload).catch(e => e);
        } else {
            res = await api.post(addproduct, payload).catch(e => e);
        }

        if (res.status === 200) {
            toast.success(editId ? 'Product updated!' : 'Product added!');
            setForm(EMPTY_FORM);
            setEditId(null);
            fetchAll();
            dispatch(getallProducts());
        } else {
            toast.error(res.message || 'Something went wrong');
        }
        setLoading(false);
    };

    const handleEdit = p => {
        setEditId(p._id);
        setForm({
            name: p.name,
            description: p.description,
            img1: p.img1,
            img2: p.img2,
            price: p.price,
            category: Array.isArray(p.category) ? p.category.join(', ') : p.category,
            tags: Array.isArray(p.tags) ? p.tags.join(', ') : p.tags,
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleDelete = async id => {
        if (!window.confirm('Delete this product?')) return;
        const res = await api.delete(deleteproduct + id).catch(e => e);
        if (res.status === 200) {
            toast.success('Product deleted');
            fetchAll();
            dispatch(getallProducts());
        } else {
            toast.error(res.message || 'Delete failed');
        }
    };

    const handleCancel = () => { setForm(EMPTY_FORM); setEditId(null); };

    return (
        <div className='adminSection'>
            <h2>{editId ? 'Edit Product' : 'Add Product'}</h2>

            <form className='adminForm' onSubmit={handleSubmit}>
                <div className='adminFormGrid'>
                    <div className='adminFormGroup'>
                        <label>Name *</label>
                        <input name='name' value={form.name} onChange={handleChange} required />
                    </div>
                    <div className='adminFormGroup'>
                        <label>Price (₹) *</label>
                        <input name='price' type='number' value={form.price} onChange={handleChange} required />
                    </div>
                    <div className='adminFormGroup'>
                        <label>Image 1 URL *</label>
                        <input name='img1' value={form.img1} onChange={handleChange} required />
                    </div>
                    <div className='adminFormGroup'>
                        <label>Image 2 URL *</label>
                        <input name='img2' value={form.img2} onChange={handleChange} required />
                    </div>
                    <div className='adminFormGroup'>
                        <label>Category (comma separated) *</label>
                        <input name='category' value={form.category} onChange={handleChange} placeholder='e.g. Men, Casual' required />
                    </div>
                    <div className='adminFormGroup'>
                        <label>Tags (comma separated)</label>
                        <input name='tags' value={form.tags} onChange={handleChange} placeholder='e.g. new, trending' />
                    </div>
                    <div className='adminFormGroup adminFormFull'>
                        <label>Description *</label>
                        <textarea name='description' rows={4} value={form.description} onChange={handleChange} required />
                    </div>
                </div>
                <div className='adminFormActions'>
                    <button className='adminBtn adminBtnGreen' type='submit' disabled={loading}>
                        {loading ? 'Saving...' : editId ? 'Update Product' : 'Add Product'}
                    </button>
                    {editId && (
                        <button className='adminBtn adminBtnGray' type='button' onClick={handleCancel}>
                            Cancel
                        </button>
                    )}
                </div>
            </form>

            <h2>All Products ({products.length})</h2>
            <table className='adminTable'>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Price</th>
                        <th>Category</th>
                        <th>Rating</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {products.map(p => (
                        <tr key={p._id}>
                            <td>{p.name}</td>
                            <td>₹ {p.price}</td>
                            <td>{Array.isArray(p.category) ? p.category.join(', ') : p.category}</td>
                            <td>{p.averageRating > 0 ? `${p.averageRating.toFixed(1)} ★` : '—'}</td>
                            <td>
                                <button className='adminBtn adminBtnGreen' onClick={() => handleEdit(p)}>Edit</button>
                                <button className='adminBtn adminBtnRed' onClick={() => handleDelete(p._id)}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AdminProducts;
